import { v4 } from "uuid";
import t from "@/lang/lang";
import { useVbsCertificateCreateMutation } from "@/services/backend/vbs/certificates/api/certificate-api";
import { useToast } from "@/shared/hooks/use-toast";
import { parseRTKQueryError } from "@/shared/components/errors/parse-r-t-k-query-error";
import { ReactNode, useEffect, useState } from "react";
import { Slot } from "radix-ui";
import { Button } from "@/shared/components/ui/button";
import { Plus, RefreshCw } from "lucide-react";
import { useProcessesProcessShowQuery } from "@/services/backend/processes/api/process-api";
import { BranchSelectFrom } from "@/services/backend/company/components/branch-select-from";
import { ServiceObjectSelectFrom } from "@/services/backend/customers/components/service-object-select-from";

export function NewCertificateButton(props: {
  processId: string;
  trigger?: ReactNode;
}) {
  const { processId, trigger } = props;
  const [createCertificate, { isLoading, error, reset }] =
    useVbsCertificateCreateMutation();
  const { data: process } = useProcessesProcessShowQuery({ id: processId });

  const branches = process?.branches ?? [];
  const serviceObjects = process?.serviceObjects ?? [];
  const [branchId, setBranchId] = useState(branches[0] ?? "");
  const [serviceObjectId, setServiceObjectId] = useState(
    serviceObjects[0] ?? "",
  );

  const disabled =
    !process ||
    !process.customerId ||
    isLoading ||
    branchId === "" ||
    serviceObjectId === "";

  const { toast } = useToast();

  useEffect(() => {
    if (error) {
      toast({
        ...parseRTKQueryError(error),
        variant: "destructive",
      });
      reset();
    }
  }, [error, toast, reset]);

  const onClick = () => {
    if (disabled) {
      return;
    }

    createCertificate({
      id: v4(),
      processId: process.id,
      companyId: process.companyId,
      branchId,
      customerId: process.customerId!,
      serviceObjectId,
    });
  };

  return (
    <div className="flex flex-col items-end gap-2">
      {branches.length !== 1 && (
        <BranchSelectFrom
          branchIds={branches}
          value={branchId}
          onValueChange={setBranchId}
        />
      )}
      {serviceObjects.length !== 1 && (
        <ServiceObjectSelectFrom
          serviceObjectIds={serviceObjects}
          customerId={process?.customerId}
          value={serviceObjectId}
          onValueChange={setServiceObjectId}
        />
      )}
      {trigger ? (
        <Slot.Root onClick={onClick}>{trigger}</Slot.Root>
      ) : (
        <Button
          onClick={onClick}
          className="space-x-2"
          disabled={disabled}
          size="sm"
        >
          {isLoading ? (
            <RefreshCw className="h-5 w-5 animate-spin" />
          ) : (
            <Plus className="h-5 w-5" />
          )}
          <span>{t("Neues Zertifikat")}</span>
        </Button>
      )}
    </div>
  );
}
